export default __webpack_public_path__ + "media/images/landlords_page/benefits_4-477ee55aecf5d8e435dec1bd3df30a6f.webp";